import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch, withDefaults } from "vue";
import { message } from "ant-design-vue";

import { RecallFlow } from "@/api/index";

export default /*#__PURE__*/_defineComponent({
  props: {
    id: { default: 0 },
    show: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(__props: any, { emit: $emit }) {

const props = __props as { id: number, show: boolean }



const recallResume = ref<string>("");
const visible = ref<boolean>(false);
const updateEvent = ref<boolean>(false);

watch(
  () => props.show,
  (val) => (visible.value = val)
);

const submitRecall = async () => {
  if (!recallResume.value) {
    message.error("请输入撤回理由");
    return;
  }

  let { Success, Message } = await RecallFlow({
    Description: recallResume.value,
    Id: props.id,
  });

  if (Success) {
    message.success("已撤回");
  } else {
    message.error(Message || "撤回失败，请稍后重试");
  }
  updateEvent.value = true;
  handleCancelResume();
};
const handleCancelResume = () => {
  recallResume.value = "";
  visible.value = false;
  $emit("close", updateEvent.value ? true : false);
  updateEvent.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    class: "modal-dialog",
    bodyStyle: {
      width: '460px',
      height: '216px',
    },
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: "撤回理由",
    onOk: submitRecall,
    onCancel: handleCancelResume
  }, {
    default: _withCtx(() => [
      _createVNode(_component_a_textarea, {
        style: {"height":"163px","padding-left":"0"},
        value: recallResume.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((recallResume).value = $event)),
        bordered: false,
        placeholder: "请填写撤回理由",
        maxlength: 100,
        "auto-size": { minRows: 5, maxRows: 5 }
      }, null, 8, ["value"])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})